import { AudioManager } from '../../../core/AudioManager';
import { AudioHandle, PositionalOptions } from '../../../core/AudioManager.types';
import { Character } from '../../Character';

export class RunAudio {
    static readonly PRELOAD = ['../assets/sounds/run.mp3'] as const;
    private static readonly SRC = RunAudio.PRELOAD[0];
    private static readonly OPTIONS: PositionalOptions = { volume: 0.8, loop: true, refDistance: 1 };

    private handle: AudioHandle | null = null;

    constructor(
        private readonly audioManager: AudioManager,
        private readonly character: Character,
    ) {}

    public play(): void {
        if (this.handle) { return; }
        this.handle = this.audioManager.playPositional(RunAudio.SRC, this.character, RunAudio.OPTIONS);
    }

    public stop(): void {
        if (!this.handle) { return; }
        this.audioManager.stopPositional(this.handle);
        this.handle = null;
    }
}
